import { actionTypes } from "./index";
import service from "../../service";
import config from "../../config";

const { API_BASE_URL } = config;

export const applyBillingContextMiddleware =
  (dispatch, history, globalActions) => (action) => {
    const processAction = (action) => {
      const baseUrl = API_BASE_URL;

      switch (action.type) {
        case actionTypes.GET_TREATMENT_LIST:
          return service
            .get(
              baseUrl +
                "Doctor/GetTreatmentList?DoctorId=" +
                localStorage.getItem("id_doctor"),
            )
            .then((res) => {
              const { data } = res;
              if (data.response_code === 2000) {
                dispatch({
                  type: actionTypes.GET_TREATMENT_LIST_SUCCESS,
                  payload: data.payload,
                });
              }
            })
            .catch((error) => {
              console.log("Service error === ", error);
            });
        case actionTypes.GET_ALL_BILL_DATA_LIST:
          return service
            .post(baseUrl + "Bill/GetAllBillData", action.request)
            .then((res) => {
              const { data } = res;
              if (data.response_code === 2000) {
                dispatch({
                  type: actionTypes.GET_ALL_BILL_DATA_LIST_SUCCESS,
                  payload: data.payload,
                });
              } else {
                dispatch({
                  type: actionTypes.GET_ALL_BILL_DATA_LIST_SUCCESS,
                  payload: [],
                });
              }
            })
            .catch((error) => {
              console.log("Service error === ", error);
            });
        case actionTypes.CREATE_BILL:
          return service
            .post(baseUrl + "Bill/Create", action.request, {
              silent: false,
              showNotification: true,
            })
            .then((res) => {
              const { data } = res;
              if (data.response_code === 2000) {
                if (action.callback) {
                  action.callback(data.payload);
                }
              }
            })
            .catch((error) => {
              console.log("Service error === ", error);
            });
        case actionTypes.UPDATE_BILL:
          return service
            .post(baseUrl + "Bill/Update", action.request)
            .then((res) => {
              const { data } = res;
              if (data.response_code === 2000) {
                if (action.callback) {
                  action.callback(data.payload);
                }
              }
            })
            .catch((error) => {
              console.log("Service error === ", error);
            });
        case actionTypes.DELETE_BILL:
          return service
            .post(baseUrl + "Bill/Delete", action.request)
            .then((res) => {
              const { data } = res;
              if (data.response_code === 2000) {
                if (action.callback) {
                  action.callback();
                }
              }
            })
            .catch((error) => {
              console.log("Service error === ", error);
            });
        case actionTypes.GET_BILL_SUMMARY:
          return service
            .post(baseUrl + "Bill/GetBillSummary", action.request)
            .then((res) => {
              const { data } = res;
              let payload = null;
              if (data.response_code === 2000) {
                payload = data.payload;
              }
              dispatch({
                type: actionTypes.GET_BILL_SUMMARY_SUCCESS,
                payload: payload,
              });
            })
            .catch((error) => {
              console.log("Service error === ", error);
            });
        case actionTypes.ADD_PAYMENT:
          return service
            .post(baseUrl + "Bill/AddPayment", action.request)
            .then((res) => {
              const { data } = res;
              if (data.response_code === 2000) {
                if (action.callback) {
                  action.callback(data.payload);
                }
              }
            })
            .catch((error) => {
              console.log("Service error === ", error);
            });
        case actionTypes.SAVE_TREATMENT:
          return service
            .post(baseUrl + "Doctor/add_treatment", action.request)
            .then((res) => {
              const { data } = res;
              if (data.response_code === 2000) {
                if (action.callback) {
                  action.callback(data.payload);
                }
              }
            })
            .catch((error) => {
              console.log("Service error === ", error);
            });
        case actionTypes.GET_TRANSACTION_SUMMARY:
          return service
            .post(baseUrl + "Bill/GetTransactionSummary", action.request)
            .then((res) => {
              const { data } = res;
              let payload = [];
              if (data.response_code === 2000) {
                payload = data.payload;
              }
              dispatch({
                type: actionTypes.GET_TRANSACTION_SUMMARY_SUCCESS,
                payload: payload,
              });
            })
            .catch((error) => {
              console.log("Service error === ", error);
            });
        default:
          dispatch(action);
      }
    };

    return processAction(action);
  };
